'use client'

import type { FC } from 'react'
import { Avatar, Typography } from '@sylveraio/design-system'
import LogOut01 from '@sylveraio/untitled-ui-icons-react/build/esm/LogOut01'
import type { UserProfileProps } from '../types'
import { useLogout } from '../utils/useLogout'

export const UserProfileDropdown: FC<Omit<UserProfileProps, 'collapsed'>> = ({
  testId = 'user-profile-dropdown',
  initials,
  organisation,
  currentTier,
}) => {
  const logout = useLogout()

  const handleLogout = async () => {
    await logout()
  }

  return (
    <div
      data-testid={testId}
      className="flex w-56 flex-col items-start rounded-md border border-default bg-high shadow-md"
    >
      <div className="flex items-center gap-x-3 self-stretch border-b border-default p-3">
        <span data-testid={`${testId}-avatar`}>
          <Avatar
            initials={initials}
            background="bg-low"
            textClassName="text-default"
            removeHoverEffect
          />
        </span>

        <div className="flex grow flex-col items-start justify-center">
          <Typography
            testId={`${testId}-organisation`}
            size="xs"
            weight="medium"
            className="max-w-32 truncate"
          >
            {organisation}
          </Typography>
          <Typography
            testId={`${testId}-tier`}
            size="xs"
            weight="regular"
            className="text-subtle"
          >
            {currentTier}
          </Typography>
        </div>
      </div>
      <div className="flex w-full py-1">
        <button
          className="flex w-full items-center px-1.5 py-px text-default hover:bg-medium-hover hover:text-content-action-default"
          onClick={handleLogout}
        >
          <div className="flex grow items-center justify-start gap-x-3 p-2.5">
            <span className="h-4 w-4 shrink-0">
              <LogOut01 className="h-4 w-4 shrink-0" />
            </span>

            <Typography
              size="sm"
              weight="medium"
              className="grow text-left !text-inherit"
            >
              Log out
            </Typography>
          </div>
        </button>
      </div>
    </div>
  )
}
